import { Level } from '../users';
import { Equipment } from './equipment';

export enum ActivityType {
  // our own functional types
  BurnFitillion = 'BurnFitillion',
  BuildFitillion = 'BuildFitillion',
  BalanceFitillion = 'BalanceFitillion',
  BoxingFitillion = 'BoxingFitillion',

  // machine zones and imports
  Stepper = 'Stepper',
  Elliptical = 'Elliptical',
  TreadmillFitillion = 'TreadmillFitillion',
  StudioBikeFitillion = 'StudioBikeFitillion',
  PowerStationFitillion = 'PowerStationFitillion',
  RowingAndPaddling = 'RowingAndPaddling',

  // imports only
  Running = 'Running',
  Cycling = 'Cycling',
  StrengthTraining = 'StrengthTraining',
  OtherCardio = 'OtherCardio',
  PilatesAndYoga = 'PilatesAndYoga',
  Swimming = 'Swimming',
  Multisport = 'Multisport',
  HIIT = 'HIIT',
  Gymnastics = 'Gymnastics',
  Climbing = 'Climbing',
  WinterSports = 'WinterSports',
  WalkingAndHiking = 'WalkingAndHiking',
  RacquetSport = 'RacquetSport',
  TeamSports = 'TeamSports',
  DanceAndAerobics = 'DanceAndAerobics',
  CombatAndMartialArts = 'CombatAndMartialArts',
}

export type AreaCategory = 'circuit'
| 'treadmill'
| 'bicycle'
| 'elliptical'
| 'step'
| 'rower'
| 'calisthenic'
| 'benchAndDumbbell'
| 'dumbbell'
| 'boxing'
| 'power';

export enum BookingState {
  // the order determines persistence value, dont re-arrange/remove items
  ConfirmedBooking,
  ProvisionalBooking,
  BookingInvite,
  ClassCancelled,
}

export enum BookingSourceType {
  App = 'App',
  PT = 'PT',
  Simulator = 'Simulator',
  ClassPass = 'ClassPass',
}

export enum RemovedReasonType {
  Cancelled = 'Cancelled',
  Missed = 'Missed',
  NotCompleted = 'NotCompleted',
  Overlapping = 'Overlapping',
}

export enum CardioOrResistance {
  Cardio = 'Cardio',
  Resistance = 'Resistance',
  Balance = 'Balance',
}

export enum WorkoutType { // number is the cycles, e.g. one in 2 minutes
  MediumStudioWorkout = 14, // 12 zones + 1 warmup + 1 warm down
  FullStudioWorkout = 23, // 20 zones + 2 warmup + 1 warmdown
  QuickStaticFunctionalWorkout = 7, // 5 zones + 1 warmup + 1 warmdown
  QuickHomeOrStaticCardioWorkout = 6, // 4 zones + 1 warmup + 1 warmdown
  MediumHomeOrStaticCardioWorkout = 11, // 2 x 4 zones + 1 warmup + 1 warmdown + 1 pauses
  FullHomeOrStaticCardioWorkout = 16, // 3 x 4 zones + 1 warmup + 1 warmdown + 2 pauses
  ExtraLongHomeOrStaticCardioWorkout = 21, // 4 x 4 zones + 1 warmup + 1 warmdown + 3 pauses
  FullStaticCardioWorkout = 26,
  ImportedWorkout = 1,
}

export class WorkoutSettingsBase {
  public level: Level;

  public isDefaultDailyMix: boolean;

  public allowBagContact: boolean;

  public cardioOrResistance: CardioOrResistance;

  public threeBodyGroups: string[]; // empty means no preference, thus all

  public ignoreProgramRecommendations?: boolean;

  public homeWorkoutInstructor?: string;

  public equipment: Equipment[];

  public activityType: ActivityType; // eg boxing

  public forceSettingsDueToAreaCategory?: boolean;
}

export interface IUserRating {
  date: Date;
  rating?: number;
  comment?: string;
  skipped: boolean;
}
